module.exports = __webpack_public_path__ + "videos/groups.0805dad.webm";